import { phaseLayoutPreviewEnabled } from "./phaseLayoutPreview.mjs";

/** The router owns selection, including browser history and direct links. */
export function phaseRouteSelection(route) {
    const { ordine, operazione } = route?.params || {};
    if (!ordine || ["undefined", "null"].includes(ordine)
        || operazione === undefined || operazione === null || operazione === "") return null;
    const operation = Number(operazione);
    if (!Number.isInteger(operation) || operation < 0) return null;
    return { ordine, operazione: operation };
}

export function samePhaseSelection(left, right) {
    return !!left && !!right && left.ordine === right.ordine
        && Number(left.operazione) === Number(right.operazione);
}

export function phaseSelectionTarget(route, ordine, operazione) {
    const selected = phaseRouteSelection({ params: { ordine, operazione } });
    const operator = route?.name === "av-operatore" && [route.params?.matricola, route.params?.nome]
        .every(value => value && !["undefined", "null"].includes(value));
    if (!selected || (!route?.params?.fase && !operator)) return null;
    return {
        name: route.name,
        params: { ...route.params, ordine: selected.ordine, operazione: String(selected.operazione) },
        query: { ...route.query },
        hash: route.hash,
    };
}

export function standardPhaseTarget(route) {
    return { name: "av-fase", params: route.params, query: route.query, hash: route.hash };
}

export function priorityPhaseLoading(store, route) {
    return (route?.name === "av-fase" || phaseLayoutPreviewEnabled(store, route))
        && store?.getters?.isLoggedIn === true && Boolean(store.getters.token);
}
